import { Button } from "@altimateai/lego";
import { LoadingButton, Stack } from "@altimateai/lego";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";

interface ConnectionFormActionsProps {
  onTestConnection: () => void;
  onBack: () => void;
  isValidating: boolean;
  isFormValid: boolean;
  isValidationSuccess: boolean;
}

const ConnectionFormActions = ({
  onTestConnection,
  onBack,
  isValidating,
  isFormValid,
  isValidationSuccess,
}: ConnectionFormActionsProps): JSX.Element => {
  return (
    <Stack direction="row" justify="between" align="center" className="al-pt-6">
      <LoadingButton
        type="button"
        variant="default"
        onClick={onTestConnection}
        loading={isValidating}
      >
        Test Connection
      </LoadingButton>
      <Stack gap="xl">
        <Button variant="outline" asChild>
          <Link to="/settings/datastores">Cancel</Link>
        </Button>
        <Stack gap="md" className="al-border-l al-ps-4">
          <Button onClick={onBack} variant="secondary">
            <IconChevronLeft size={16} />
            Back
          </Button>
          <Button type="submit" disabled={!isFormValid || !isValidationSuccess}>
            Next
            <IconChevronRight size={16} />
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ConnectionFormActions;
